<template>
    <b-container>
        <b-card no-body>
            <issues/>
        </b-card>
    </b-container>
</template>

<script>
    import Issues from "@/components/issues/Issues";
    export default {
        name: "IssuesPage",
        components: {Issues}
    }
</script>
